module.exports = __webpack_public_path__ + "static/media/section7.f5411868.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/quiz/image/section7.png
// module id = 303
// module chunks = 0